module.exports = __webpack_public_path__ + "img/顶0.6eeace73.png";